import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useTheme } from "../ThemeContext";
import { useState, useEffect } from "react";

export default function Footer() {
  const [theme, setTheme] = useState("light");

  useEffect(() => {
    const currentTheme =
      document.documentElement.getAttribute("data-theme") || "light";
    setTheme(currentTheme);

    const observer = new MutationObserver(() => {
      const newTheme =
        document.documentElement.getAttribute("data-theme") || "light";
      setTheme(newTheme);
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["data-theme"],
    });

    return () => observer.disconnect();
  }, []);
  return (
    <>
      <div className="footer overflow-hidden position-relative">
        {/* <div className="waves">
          <div className="wave" id="wave1"></div>
          <div className="wave" id="wave2"></div>
          <div className="wave" id="wave4"></div>
        </div> */}
        <footer className="text-start space60 pb-0 position-relative">
          <div className="container">
            <div className="row ps-sm-0 ps-4">
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="col-md-12 col-lg-12 col-xl-3 mx-auto mt-lg-3 mt-4 mb-xl-0 mb-lg-4"
              >
                <Link className="navbar-brand" to="/">
                  <img
                    src={
                      theme === "dark"
                        ? "/assets/images/logo/dark-logo.svg"
                        : "/assets/images/logo/logo.svg"
                    }
                    alt="Logo"
                    className="mb-3"
                  />
                </Link>
                <p className="mb-lg-3 mb-1">
                  Building decentralized solutions for a secure digital future.
                  Connect with us to bring your blockchain vision to life.
                </p>
                <Link
                  to="https://www.facebook.com/profile.php?id=61577467141325"
                  className="btn border btn-floating my-1 me-3 social_btn"
                  role="button"
                  target="_blank"
                >
                  <i className="fab fa-facebook-f" />
                </Link>
                <Link
                  to="https://x.com/blockcrypdev"
                  target="_blank"
                  className="btn border btn-floating my-1 me-3 social_btn"
                  role="button"
                >
                  <i className="fab fa-twitter" />
                </Link>
                <Link
                  to="https://www.instagram.com/blockcrypdev/"
                  target="_blank"
                  className="btn  border btn-floating my-1 me-3 social_btn"
                  role="button"
                >
                  <i className="fab fa-instagram" />
                </Link>
              </motion.div>
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="col-12 col-sm-6 col-lg-3 col-xl-2 ps-xl-5 mt-lg-3 mt-4"
              >
                <h6 className="border_block position-relative text-uppercase mb-4 fw-bold">
                  Pages
                </h6>
                <ul>
                  <li className="mb-3">
                    <Link to="/about" className="">
                      About Us
                    </Link>
                  </li>
                  <li className="mb-3">
                    <Link to="/partners" className="">
                      Partners
                    </Link>
                  </li>
                  <li className="mb-3">
                    <Link to="/contact" className="">
                      Contact Us
                    </Link>
                  </li>
                  <li className="mb-3">
                    <Link to="/blog" className="">
                      Blog
                    </Link>
                  </li>
                  <li className="mb-3">
                    <Link to="/career" className="">
                      Career
                    </Link>
                  </li>
                  <li className="mb-3">
                    <Link to="/productdetails" className="">
                      Product Details
                    </Link>
                  </li>
                </ul>
              </motion.div>
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="col-12 col-sm-6 col-lg-3 col-xl-3 ps-xl-5 ps-lg-0 mt-lg-3 mt-4"
              >
                <h6 className="border_block position-relative text-uppercase mb-4 fw-bold">
                  Quick links
                </h6>
                <ul>
                  <li className="mb-3">
                    <Link to="/blockchain_development" className="">
                      Blockchain Development
                    </Link>
                  </li>
                  <li className="mb-3">
                    <Link to="/metaverse_development" className="">
                      Metaverse Development
                    </Link>
                  </li>
                  <li className="mb-3">
                    <Link to="/cryptocurrency" className="">
                      Cryptocurrency Exchange
                    </Link>
                  </li>
                  <li className="mb-3">
                    <Link to="/smartcontract" className="">
                      Smart Contract
                    </Link>
                  </li>
                  <li className="mb-3">
                    <Link to="/tokenization" className="">
                      Asset Tokenization
                    </Link>
                  </li>
                </ul>
              </motion.div>
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="col-sm-6 col-lg-3 col-xl-2 mt-lg-3 mt-4"
              >
                <h6 className="border_block position-relative text-uppercase mb-4 fw-bold">
                  Quick Links
                </h6>
                <ul>
                  <li className="mb-3">
                    <Link to="/exchange" className="">
                      Custom Exchange
                    </Link>
                  </li>
                  <li className="mb-3">
                    <Link to="/nftmarketplace" className="">
                      NFT Marketplace
                    </Link>
                  </li>
                  <li className="mb-3">
                    <Link to="/botdevelopment" className="">
                      Arbitrage Bots
                    </Link>
                  </li>
                  <li className="mb-3">
                    <Link to="/aidevelopment" className="">
                      AI Agent Development
                    </Link>
                  </li>
                  <li className="mb-3">
                    <Link to="/tokencoin" className="">
                      Coin/Token Development
                    </Link>
                  </li>
                </ul>
              </motion.div>
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="col-sm-6 col-lg-3 col-xl-2 ps-xl-5 ps-lg-0 mt-lg-3 mt-4"
              >
                <h6 className="border_block position-relative text-uppercase mb-4 fw-bold">
                  Quick Links
                </h6>
                <ul>
                  <li className="mb-3">
                    <Link to="/defi" className="">
                      DeFi Development
                    </Link>
                  </li>
                  <li className="mb-3">
                    <Link to="/web3development" className="">
                      Web 3.0 Development
                    </Link>
                  </li>
                </ul>
              </motion.div>

              {/* <motion.div
                  initial={{ opacity: 0, y: 50 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 1, delay: 0.5 }}
                  viewport={{ once: false, amount: 0.5 }}
                  className="col-sm-4 col-lg-3 col-xl-3 mx-auto mt-lg-3 mt-4"
                >
                  <h6 className="text-uppercase mb-4 fw-bold">Contact</h6>
                  <ul>
                    <li className="mb-3">
                      <i className="fas fa-envelope me-2" /> abc@gmail.com
                    </li>
                  </ul>
                </motion.div> */}
            </div>
            <hr className="my-3" />
            <section className="p-3 pt-0">
              <div className="row d-flex align-items-center">
                <div className="col-md-12 col-lg-12 text-center ">
                  <motion.div
                    className="p-1 mb-md-0"
                    initial={{ opacity: 0, x: -50 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 1, delay: 0.5 }}
                    viewport={{ once: false, amount: 0.5 }}
                  >
                    © Copyright 2025 Blockcryp. All Rights Reserved.
                  </motion.div>
                </div>
                {/* <motion.div
                  className="col-md-5 col-lg-4 ml-lg-0 text-center text-md-end"
                  initial={{ opacity: 0, x: 50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 1, delay: 0.5 }}
                  viewport={{ once: false, amount: 0.5 }}
                >
                  <Link to="#"><i className="fas fa-envelope me-2" /> blockcryp833@gmail.com</Link>
                </motion.div> */}
              </div>
            </section>
          </div>
        </footer>
      </div>
    </>
  );
}

// <motion.div
//               initial={{ opacity: 0, y: 50 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               transition={{ duration: 1, delay: 0.5 }}
//               viewport={{ once: false, amount: 0.5 }}
//               className="col-sm-4 col-lg-2 col-xl-2 mx-auto mt-lg-3 mt-4"
//             >
//               <h6 className="text-uppercase mb-4 fw-bold">Quick Links</h6>
//               <ul>
//                 <li className="mb-3">
//                   <Link to="" className="">
//                     Listing
//                   </Link>
//                 </li>
//                 <li className="mb-3">
//                   <Link to="" className="">
//                     Consulting
//                   </Link>
//                 </li>
//                 <li className="mb-3">
//                   <Link to="" className="">
//                     Crypto Solutions
//                   </Link>
//                 </li>
//                 <li className="mb-3">
//                   <Link to="" className="">
//                     BlockChain
//                   </Link>
//                 </li>
//                 <li className="mb-3">
//                   <Link to="" className="">
//                     About Us
//                   </Link>
//                 </li>
//                 <li className="mb-3">
//                   <Link to="/contact" className="">
//                     Contact Us
//                   </Link>
//                 </li>
//               </ul>
//             </motion.div>
